class FostrModal extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define('fostr-modal', FostrModal)

class FostrModalCurtain extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Event Listeners
    this.addEventListener('click',this.hideModal.bind(this))
  }

  disconnectedCallback() {}

  hideModal() {

    this.parentNode.classList.remove('active')
    setTimeout(function() {
      document.documentElement.classList.remove('fostr-modal--isVisible')
    }, 300);
    document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('fostr-modal-curtain', FostrModalCurtain)

class FostrModalOpener extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    // Event Listeners
    this.addEventListener('click',this.showModal.bind(this))
  }

  disconnectedCallback() {}

  showModal() {
    if (!this.id) return;
    document.documentElement.classList.add('fostr-modal--isVisible')
    document.getElementById('fostr-modal-' + this.id).classList.add('active')
    document.body.classList.add('overflow-hidden');
  }
}
customElements.define('fostr-modal-opener', FostrModalOpener)


class FostrModalClose extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Event Listeners
    this.addEventListener('click',this.hideModal.bind(this))
  }

  disconnectedCallback() {}

  hideModal() {
    this.parentNode.parentNode.parentNode.classList.remove('active')
    setTimeout(function() {
      document.documentElement.classList.remove('fostr-modal--isVisible')
    }, 300);
    document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('fostr-modal-close', FostrModalClose)
